import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import ReserveRequest from "../../magData/Hotel/ReserveRequest";
import ReserveResponse from "../../magData/Hotel/ReserveResponse";

function HotelReservePage(props) {

  return (
    <>
      <Container fluid>
        <Row>
          <Col sm={12}>
            <p className="page-title">Hotel Reserve Method</p>
          </Col>
          <Col sm={12}>
            <p>EndPoint : https://gdscpapi.parsgds.com/gateway/Hotel/reserve</p>
          </Col>
          <Col sm={12}>
            <p> type : json (default)</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <p>Body Parameters</p>
          </Col>
          <Col sm={12}>
            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>gdsRefrenceID</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>phoneNumber</td>
                  <td>phoneNumber</td>
                  <td>String</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>email</td>
                  <td>email</td>
                  <td>String</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>note</td>
                  <td>note</td>
                  <td>String</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>Rooms</td>
                  <td>Rooms</td>
                  <td>Object</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>

                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>passengers</td>
                          <td>
                            <p>passengers</p>
                          </td>
                          <td>Object</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <Table bordered>
                              <tbody>
                                <tr>
                                  <td>firstName</td>
                                  <td>firstName</td>
                                  <td>string</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>
                                <tr>
                                  <td>lastName</td>
                                  <td>lastName</td>
                                  <td>string</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>
                                <tr>
                                  <td>passengerType</td>
                                  <td>passengerType</td>
                                  <td>integer</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>
                                <tr>
                                  <td>passengerGender</td>
                                  <td>passengerGender</td>
                                  <td>integer</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>
                                <tr>
                                  <td>childAge</td>
                                  <td>childAge</td>
                                  <td>integer</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>
                                <tr>
                                  <td>nationalID</td>
                                  <td>nationalID</td>
                                  <td>string</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>
                                <tr>
                                  <td>passportNumber</td>
                                  <td>passportNumber</td>
                                  <td>string</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>

                <tr>
                  <td>hotelTransfers</td>
                  <td>hotelTransfers</td>
                  <td>Object</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>

                        <tr>
                          <td>transferType</td>
                          <td>transferType</td>
                          <td>integer</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>                          </td>
                        </tr>
                        <tr>
                          <td>serviceType</td>
                          <td>serviceType</td>
                          <td>integer</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>                          </td>
                        </tr>

                        <tr>
                          <td>airLine</td>
                          <td>airLine</td>
                          <td>String</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>flightNo</td>
                          <td>flightNo</td>
                          <td>String</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>arrivalTime</td>
                          <td>arrivalTime</td>
                          <td>String</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>departureTime</td>
                          <td>departureTime</td>
                          <td>String</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>phonePassenger</td>
                          <td>phonePassenger</td>
                          <td>String</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <span className="code-section-title">
              Request Formats - application/json, text/json
            </span>
          </Col>
          <Col sm={12}>
            <pre className="code-section">
              {JSON.stringify(ReserveRequest, null, 2)}
            </pre>
          </Col>
        </Row>

        {/* Response  */}
        <Row>
          <Col sm={12}>
            <p>Response Information</p>
          </Col>
          <Col sm={12}>
            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>PaymentDeadline</td>
                  <td>
                    <p>Payment Deadline</p>
                  </td>
                  <td>date</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>vatNumber</td>
                  <td>
                    <p>vatNumber</p>
                  </td>
                  <td>string</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>

                <tr>
                  <td>totalPrice</td>
                  <td>totalPrice</td>
                  <td>integer</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>Remarks</td>
                  <td>
                    <p>Remarks</p>
                  </td>
                  <td>Collection of string</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>cancelationPolicyChange</td>
                  <td>cancelationPolicyChange</td>
                  <td>string</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>gdsRefrenceID</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <span className="code-section-title">
              Response Formats - application/json, text/json
            </span>
          </Col>
          <Col sm={12}>
            <pre className="code-section">
              {JSON.stringify(ReserveResponse, null, 2)}
            </pre>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default HotelReservePage;